import { getMediaPresignUrl } from './UrlUtilities';

// File extension → basename fallback when the browser can't infer one.
function extFromFile(file) {
    const dot = (file.name || '').lastIndexOf('.');
    if (dot >= 0) return file.name.slice(dot + 1).toLowerCase();
    // Fall back to the subtype of the MIME type (e.g. image/png → png).
    const slash = (file.type || '').indexOf('/');
    return slash >= 0 ? file.type.slice(slash + 1).toLowerCase() : '';
}

// Upload an image/audio file to S3 via a backend-issued presigned PUT URL and
// return its final public URL. `callApi` is the useApiCaller() function.
// `kind` is "image" or "audio". Throws on failure (caller surfaces via ErrorContext).
export async function uploadMediaToS3(callApi, file, kind) {
    const ext = extFromFile(file);
    const presign = await callApi({
        url: getMediaPresignUrl(),
        method: 'POST',
        token: true,
        payload: { kind, content_type: file.type || 'application/octet-stream', ext },
    });
    if (!presign || !presign.success || !presign.data) {
        throw new Error('Could not get an upload URL');
    }
    const { upload_url, file_url } = presign.data;
    const put = await fetch(upload_url, {
        method: 'PUT',
        headers: { 'Content-Type': file.type || 'application/octet-stream' },
        body: file,
    });
    if (!put.ok) {
        throw new Error(`Upload failed (${put.status})`);
    }
    return file_url;
}
